const headerStyle = { backgroundColor: "#FFDB8A", color: "#333", fontWeight: "bold" };
const dataStyle = { backgroundColor: "#E5E7EB", color: "#333", fontWeight: "bold" };
const metricStyle = { backgroundColor: "#BAE6FD", color: "#333", fontWeight: "bold" };

const sortWithTotalLast = (a, b, order, _dataField, rowA, rowB) => {
  if (rowA.nomeFunc === "Total") return 1;
  if (rowB.nomeFunc === "Total") return -1;
  const valA = a ?? "";
  const valB = b ?? "";
  if (order === "asc") return valA > valB ? 1 : valA < valB ? -1 : 0;
  return valA < valB ? 1 : valA > valB ? -1 : 0;
};

export const colunasDesempenho = [
  {
    dataField: "nomeFunc",
    text: "Vendedora",
    headerAlign: "center",
    align: "center",
    headerStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "codFunc",
    text: "Cód. Func",
    headerAlign: "center",
    align: "center",
    headerStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "codLoja",
    text: "Cód. Loja",
    headerAlign: "center",
    align: "center",
    headerStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "gestantesUnicasDisponiveis",
    text: "Gestantes",
    headerAlign: "center",
    align: "center",
    headerStyle: metricStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "clientesNaFila",
    text: "Na fila",
    headerAlign: "center",
    align: "center",
    headerStyle: metricStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "clientesPendentesResultado",
    text: "Resultado pendente",
    headerAlign: "center",
    align: "center",
    headerStyle: metricStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "totalContatos",
    text: "Contatos realizados (únicos)",
    headerAlign: "center",
    align: "center",
    headerStyle: metricStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
    formatter: (cell, row) => `${cell} (${row.contatosUnicos ?? 0})`,
  },
  {
    dataField: "conversoes",
    text: "Venda Iniciada",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "vendasFinalizadas",
    text: "Conversões",
    headerAlign: "center",
    align: "center",
    headerStyle: metricStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
    formatter: (cell, row) => {
      const taxa = parseFloat(row.taxaConversao || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
      return `${cell} (${taxa}%)`;
    },
  },
  {
    dataField: "semRetorno",
    text: "Sem Retorno",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "followUps",
    text: "Follow-up",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "aguardando",
    text: "Aguardando",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
  {
    dataField: "optOuts",
    text: "Opt-outs",
    headerAlign: "center",
    align: "center",
    headerStyle: dataStyle,
    sort: true,
    sortFunc: sortWithTotalLast,
  },
];
